angular.module('rjmNg.directives').directive "datePicker", [
  () ->
    restrict: "E"
    templateUrl: "directive.datePicker.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      inputDate: "="
      weekStartDay: "=" # Pass here Clients.get(CLIENT_ID) -> clientInfo.properties.week_start_day
      format: "@"
    controller: [
      "$scope"
      (
        $scope
      ) ->
        view = @

        DAYS_OF_THE_WEEK = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
        NUMBER_OF_DAYS_IN_CALENDAR = 41 # = 6*7-1
        view.MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        view.INVALID_DATE = "Invalid date"
        view.years = []
        view.inputDateUpdatedByDirective = false

        _createEmptyDayBuckets = () ->
          view.dayBuckets = []
          for i in [0..NUMBER_OF_DAYS_IN_CALENDAR]
            view.dayBuckets.push(
              date: null
              month: null
              year: null
            )

        _createDaysOfTheWeekList = () ->
          if view.weekStartDayNumber is 0
            view.daysOfTheWeek = DAYS_OF_THE_WEEK
          else
            view.daysOfTheWeek = []
            view.daysOfTheWeek.push(DAYS_OF_THE_WEEK[i]) for i in [view.weekStartDayNumber..6]
            view.daysOfTheWeek.push(DAYS_OF_THE_WEEK[i]) for i in [0..view.weekStartDayNumber-1]

        view.generateYears = (maxYear) ->
          view.years = []
          view.years.push(year) for year in [maxYear..1970]

        view.updateCalendar = () ->
          firstDayInCurrentMonth = moment({year: view.localDay.year, month: view.localDay.month, date: 1})

          firstDayOfMonthAbsoluteNumber = firstDayInCurrentMonth.day()
          dayDiff = firstDayOfMonthAbsoluteNumber - view.weekStartDayNumber
          firstDayOfMonthRelativeNumber = if dayDiff < 0 then 7 + dayDiff else dayDiff

          daysInCurrentMonth = firstDayInCurrentMonth.daysInMonth()

          # Current month
          for i in [0..daysInCurrentMonth-1]
            index = i + firstDayOfMonthRelativeNumber
            view.dayBuckets[index].date = i + 1
            view.dayBuckets[index].month = view.localDay.month
            view.dayBuckets[index].year = view.localDay.year

          # Next month
          dayCount = 0
          for i in [firstDayOfMonthRelativeNumber+daysInCurrentMonth..NUMBER_OF_DAYS_IN_CALENDAR]
            view.dayBuckets[i].date = dayCount += 1
            view.dayBuckets[i].month = if view.localDay.month is 11 then 0 else view.localDay.month + 1
            view.dayBuckets[i].year = if view.localDay.month is 11 then view.localDay.year + 1 else view.localDay.year

          # Last month
          unless firstDayOfMonthRelativeNumber is 0
            firstDayInLastMonth = firstDayInCurrentMonth.subtract(1, 'months')
            lastMonthLastDay = firstDayInLastMonth.daysInMonth()
            lastMonth = firstDayInLastMonth.month()
            for i in [0..firstDayOfMonthRelativeNumber-1]
              view.dayBuckets[i].date = i + 1 + lastMonthLastDay - firstDayOfMonthRelativeNumber
              view.dayBuckets[i].month = lastMonth
              view.dayBuckets[i].year = if view.localDay.month is 0 then view.localDay.year - 1 else view.localDay.year

        view.selectDay = (day) ->
          view.localDay = angular.copy(day)

        view.initialize = () ->
          _createDaysOfTheWeekList()
          _createEmptyDayBuckets()
          isInputDateValid = view.inputDate? and view.format? and
            moment(view.inputDate, view.format).format() isnt view.INVALID_DATE

          date = if isInputDateValid then moment(view.inputDate, view.format) else moment()
          view.localDay =
            date: if isInputDateValid then date.date() else null
            year: date.year()
            month: date.month()
          view.generateYears(view.localDay.year+5)
          view.updateCalendar()

        view.$onInit = () ->
          view.weekStartDay ?= 7 # By default it is Sunday (rjm: Sunday -> Saturday: 7 1 2 3 4 5 6)
          # This is weekStartDay converted to moment.js format (moment.js: Sunday -> Saturday: 0 1 2 3 4 5 6)
          view.weekStartDayNumber = view.weekStartDay%7
          view.initialize()

        view
    ]
    link: (scope, element, attr, view) ->
      _correctedDate = (day) ->
        if moment(day).format() is view.INVALID_DATE
          _correctedDate(year: day.year, month: day.month, date: day.date-1)
        else
          return day.date

      scope.$watch(
        'view.localDay'
        (newLocalDay, oldLocalDay) ->
          if newLocalDay isnt oldLocalDay
            monthChanged = newLocalDay.month isnt oldLocalDay.month
            yearChanged = newLocalDay.year isnt oldLocalDay.year
            dateValid = view.localDay.date?

            if monthChanged or yearChanged
              view.updateCalendar()
              if dateValid
                newLocalDay.date = _correctedDate(newLocalDay)

            if yearChanged and newLocalDay.year+1 not in view.years
              view.generateYears(newLocalDay.year+1)

            if dateValid
              view.inputDateUpdatedByDirective = true
              view.inputDate = moment(newLocalDay).format(view.format)
        true
      )

      scope.$watch 'view.inputDate', (newInputDate, oldInputDate) ->
        if newInputDate isnt oldInputDate
          if view.inputDateUpdatedByDirective
            view.inputDateUpdatedByDirective = false
          else
            view.initialize()
]
